import { isEmpty, map } from "lodash";
import styles from "../MapView.module.scss";
import { ResultGoogleType } from "imagica-corekit/dist/base/api/mapTyped/GoogleMap";
import { MapViewBloc } from "../MapViewBloc";
import { MapImg } from "./img/Index";
import { MapToolTip } from "./tooltip/Index";
import cls from "classnames";

type CanvasProps = {
  id: string;
  bloc: MapViewBloc;
  height: number;
  noWheelClassName: string;
};

export function PreviewView(props: CanvasProps) {
  const mapboxClassName = cls(styles.mapboxContent, "nodrag", "nowheel");

  return (
    <div className={styles.mapboxPreview}>
      {/* map */}
      <div className={mapboxClassName}>
        <div id={props.id} className={styles.inner}></div>
        {/* tooltip */}
        {!isEmpty(props.bloc.tipError.value) && <MapToolTip bloc={props.bloc} />}
        {/* tool */}
        <div className={styles.mapToolBox}>
          <span className="iconfont icon-tianjia" onClick={e => props.bloc.zoomIn(e)}></span>
          <span className="iconfont icon-jianshao" onClick={e => props.bloc.zoomOut(e)}></span>
        </div>
      </div>
      <div
        className={`${styles.previewRestaurantbox} ${props.noWheelClassName}`}
        style={{ height: props.height - 360 }}
      >
        {isEmpty(props.bloc.mapList.value) ? (
          <div className={styles.noData}>No data.</div>
        ) : (
          map(props.bloc.mapList.value, (address: ResultGoogleType, index: number) => {
            return (
              <div className={styles.restaurantItem} key={address?.place_id || "" + index}>
                <MapImg placeId={address?.place_id || ""} />
                <div>{address.name}</div>
                <p className={styles.xingP}>
                  {address.rating && (
                    <span>
                      {address.rating} <span className="iconfont icon-wujiaoxing-"></span>
                    </span>
                  )}
                  {address.user_ratings_total && `(${address.user_ratings_total})`}
                </p>
                <p>{props.bloc.getAddressDetail(address)}</p>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
